import styles from "./Categories.module.css";
import checkIcon from "../../../../assets/icons/Check.png";

type CategoriesProps = {
  data: string[];
  activeCategory: string;
  setActiveCategory: (category: string) => void;
  progressActiveCategory: number;
  completedCategories: string[];
};

const classNames = (...classes: Array<string | undefined | false>) =>
  classes.filter(Boolean).join(" ");

export default function Categories({
  data,
  activeCategory,
  setActiveCategory,
  progressActiveCategory,
  completedCategories = [],
}: CategoriesProps) {
  if (!data?.length) {
    return null;
  }

  const isCompleted = (name: string) => completedCategories.includes(name);

  return (
    <nav className={styles.wrapper} aria-label="Categorias do questionário">
      <ul className={styles.list}>
        {data.map((name, index) => {
          const completed = isCompleted(name);
          const active = name === activeCategory;
          const progress = Math.max(
            0,
            Math.min(100, progressActiveCategory || 0)
          );

          return (
            <div className={styles.itemContainer} key={`category-${name}`}>
              <li
                key={name}
                className={classNames(
                  styles.item,
                  completed && styles.itemDone,
                  active && styles.itemActive
                )}
                aria-current={active ? "step" : undefined}
              >
                <button
                  className={styles.categoryButton}
                  onClick={() => setActiveCategory(name)}
                >
                  <span
                    className={classNames(
                      styles.indicator,
                      completed && styles.indicatorDone,
                      active && styles.indicatorActive
                    )}
                    aria-hidden="true"
                  >
                    {active ? (
                      <svg
                        className={styles.progressCircle}
                        viewBox="0 0 36 36"
                        fill="none"
                      >
                        {/* Outer progress ring */}
                        <circle
                          className={styles.progressRing}
                          cx="18"
                          cy="18"
                          r="21"
                          stroke="#e5e7eb"
                          strokeWidth="2"
                          fill="none"
                        />
                        <circle
                          className={styles.progressRingFill}
                          cx="18"
                          cy="18"
                          r="21"
                          stroke="#186BCE"
                          strokeWidth="2"
                          fill="none"
                          strokeDasharray={`${2 * Math.PI * 21}`}
                          strokeDashoffset={`${
                            2 * Math.PI * 21 * (1 - progress / 100)
                          }`}
                          transform="rotate(-90 18 18)"
                        />
                        {/* Inner blue circle */}
                        <circle cx="18" cy="18" r="18" fill="#186BCE" />
                        {/* White number */}
                        <text
                          x="18"
                          y="18"
                          textAnchor="middle"
                          dominantBaseline="central"
                          fill="white"
                          fontSize="16"
                          fontWeight="400"
                        >
                          {index + 1}
                        </text>
                      </svg>
                    ) : completed ? (
                      <img
                        className={styles.checkIcon}
                        src={checkIcon}
                        alt="Check"
                      />
                    ) : (
                      index + 1
                    )}
                  </span>

                  <div className={styles.content}>
                    <p
                      className={classNames(
                        styles.label,
                        !completed && !active && styles.labelMuted
                      )}
                    >
                      {name}
                    </p>
                  </div>
                </button>
              </li>
              {index < data.length - 1 && (
                <li
                  key={`connector-${name}`}
                  className={`${styles.connector} ${
                    completed ? styles.connectorCompleted : ""
                  }`}
                ></li>
              )}
            </div>
          );
        })}
      </ul>
    </nav>
  );
}
